<template>
  <div>
    <!-- /.box-header -->
    <section class="content-header" style="height: 50px;">
      <a v-if="0>1" href="#" @click="$root.showNewBox" style="float: left; padding-right: 10px;"><i class="fa fa-plus-circle" style="font-size: 30px;"></i></a>
      <h1 style="float: left; padding-right: 10px;">{{ $root.title}}</h1>
      <div action="#" method="get" class="sidebar-form" style="width: 200px; float: right; margin: 0px; border: 1px solid #337ab7;">
        <div class="input-group">
          <input type="text" name="q" class="form-control" placeholder="Search..." v-model="$root.txtSearch" style="height: 27px; background-color: #fff;">
          <div class="input-group-btn">
            <div class="btn btn-flat" style="height: 28px; padding: 4px 6px; background-color: #fff;"><i class="fa fa-search"></i></div>
          </div>
        </div>
      </div>
    </section>
    <div class="box-body">
      <div class="table-responsive">
        <div v-show="$root.isAdmin" class="col-sm-12" style="padding-left: 0px; background-color: #ddd; padding-bottom: 10px; border-radius: 5px;">
          <div class="col-sm-2">
            <span>Select Dealer:</span>
            <select class="form-control" v-model="filters.dealerKey" style="padding-left: 0px;">
              <option value="All">All</option>
              <option v-for="(item,index) in sortedDealers" :value="item.value">{{ item.title }}</option>
            </select>
          </div>
          <div class="col-sm-2" style="height: 54px;">
            <input type="button" class="btn btn-success" value="Refresh" style="margin-top: 20px;" @click="loadCustomers" />
          </div>
          <div v-if="isLocal" class="col-sm-2" style="height: 54px;">
            <span>Select Date:</span>
            <select class="form-control" v-model="selectedMonth" style="padding-left: 0px;">
              <option v-for="(item,index) in lstDates" :value="item">{{ item }}</option>
            </select>
          </div>
          <div v-if="isLocal" class="col-sm-2" style="height: 54px;">
            <input type="button" class="btn btn-danger" value="Collect Counters" style="margin-top: 20px;" @click="collectAllCounters(false)" />
          </div>
          <div v-if="isLocal" class="col-sm-3" style="height: 54px;">
            <h5>Total : {{progressCounters.Total}} / Success: {{progressCounters.Success}} / Failed: {{progressCounters.Failed}}</h5>
          </div>
        </div>
        <!--<div v-if="isLoading" class="spinner"></div>-->
        <VueTable :columns="columns" :isLoading="isLoading" :rows="filteredItems" @rowClick="rowClick"></VueTable>
      </div>
      <!-- /.table-responsive -->
    </div>
    <AddCustomer></AddCustomer>
    <loading :active.sync="isLoading" :is-full-page="isFullpage"></loading>
  </div>
</template>
<script>
  import VueTable from '../components/Table/DataTable.vue'
  import AddCustomer from '../components/AddCustomer'
  import Modal from '../components/Modal'
  import VAAlert from '../components/VAAlert.vue'
  import { db, dbStore } from '../firebase'
  // import { InitCounters, LoadCounters, GetHistoryCounters, UpdateHistoryCounters } from '../plugins/countersHistory.js'
  import { HistoryCounters } from '../plugins/countersHistory.js'
  import Loading from 'vue-loading-overlay'
  import DownloadInstaller from '../components/DownloadInstaller'

  export default {
    name: 'customers',
    components: {
      VueTable,
      'va-alert': VAAlert,
      AddCustomer,
      'va-modal': Modal,
      DownloadInstaller,
      Loading
    },
    data () {
      return {
        isLoading: false,
        isFullpage: true,
        progressCounters: {
          Total: 0,
          Success: 0,
          Failed: 0
        },
        filters: {
          dealerKey: '',
          customerKey: '',
          siteKey: ''
        },
        customers: [],
        columns: [
          { fieldName: '.key', label: 'Key', isSortable: true, isHidden: false },
          { fieldName: 'Name', label: 'Customer Name', isSortable: true, isHidden: false },
          { fieldName: 'Dealer', label: 'Dealer Name', isSortable: true, isHidden: false },
          // { fieldName: 'Email', label: 'Email', isSortable: true, isHidden: false },
          // { fieldName: 'Address', label: 'Address', isSortable: true, isHidden: false },
          // { fieldName: 'Phone', label: 'Phone', isSortable: true, isHidden: false },
          { fieldName: 'TotalSites', label: 'Total Sites', isSortable: true, isHidden: false },
          { fieldName: 'TotalPrinters', label: 'Total Printers', isSortable: true, isHidden: false },
          {
            fieldName: 'VueBottons',
            isSortable: false,
            isHidden: false,
            bottons: [
              { name: 'Edit', label: 'Edit', iconClass: 'fa fa-edit', color: 'green' },
              { name: 'Delete', label: 'Delete', iconClass: 'fa fa-trash-o', color: 'red' }
            ]
          }
        ],
        selectedMonth: '',
        lstDates: [],
        isLocal: false
      }
    },
    created () {
      this.$root.title = 'Customers'
      if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
        // alert('It is a local server!')
        this.lstDates = []
        for (var m = 1; m <= 10; m++) {
          if (m < 10) {
            this.lstDates.push(2021 + '/0' + m)
          } else {
            this.lstDates.push(2021 + '/' + m)
          }
        }
        this.isLocal = true
      }
      if (this.$root.isAdmin) {
        if (this.$root.userHistory) {
          this.filters.dealerKey = this.$root.userHistory.selectedDealer
          this.filters.customerKey = this.$root.userHistory.selectedCustomer
          this.filters.siteKey = this.$root.userHistory.selectedSite
        }
      } else if (this.$root.isDealerAssistance) {
        this.filters.dealerKey = this.$root.user.DealerUID
        this.loadCustomers()
      } else {
        this.filters.dealerKey = this.$root.user['.key']
        this.loadCustomers()
      }
    },
    watch: {
      'filters.dealerKey' (val) {
        console.log('filters.dealerKey = ' + val)
        this.customers = []
        if (!this.$root.isAdmin) {
          this.loadCustomers()
        }
      }
    },
    computed: {
      hasData () {
        return this.filteredItems !== null && this.filteredItems !== undefined && this.filteredItems.length > 0
      },
      filteredItems () {
        const vm = this
        let result = []
        if (vm.$root.txtSearch.length > 0) {
          let txtSearch = vm.$root.txtSearch.trim().toLowerCase()
          try {
            result = vm.customers.filter(function (row) {
              return Object.keys(row).some(function (key) {
                if (String(row[key]).trim().toLowerCase().indexOf(txtSearch) > -1) {
                  return row
                }
              })
            })
          } catch (e) {
            console.log(e)
            result = []
          }
        } else {
          result = vm.customers
        }
        console.log(result)
        return result
      },
      sortedDealers () {
        let vm = this
        return vm.$root.dealers.sort(vm.compareItems)
      }
    },
    methods: {
      compareItems (a, b) {
        try {
          const nameA = a.title.toUpperCase()
          const nameB = b.title.toUpperCase()
          if (nameA < nameB) return -1
          if (nameA > nameB) return 1
          return 0
        } catch (e) {
          return 0
        }
      },
      loadCustomers () {
        console.log('loadCustomers()...')
        const vm = this
        vm.customers = []
        if (vm.filters.dealerKey === 'All') {
          vm.loadAllCustomers()
        } else {
          vm.loadDealerCustomers()
        }
      },
      loadAllCustomers () {
        console.log('loadAllCustomers()...')
        let vm = this
        vm.isLoading = true
        vm.customers = []
        for (let i = 0; i < vm.$root.customers.length; i++) {
          let currentCustomer = vm.$root.customers[i]
          let dealer = vm.$root.dealers.find(d => {
            return d.value === currentCustomer.dealerKey
          })
          console.log(currentCustomer)
          let customer = {
            '.key': currentCustomer.value,
            CustomerKey: currentCustomer.value,
            NameOLD: currentCustomer.Name,
            Name: currentCustomer.title,
            Email: '',
            Address: '',
            Phone: '',
            TotalPrinters: 0,
            TotalSites: 0,
            Dealer: dealer ? dealer.title : '',
            DealerKey: dealer ? dealer.value : ''
          }

          vm.customers.push(customer)
        }
        vm.isLoading = false
      },
      loadDealerCustomers () {
        console.log('loadDealerCustomers()...')
        const vm = this
        vm.isLoading = true
        let dealer = vm.$root.dealers.find(d => {
          return d.value === vm.filters.dealerKey
        })
        let customersPath = 'Dealers/' + vm.filters.dealerKey + '/Customers'
        let customersRef = db.ref(customersPath)
        customersRef.orderByKey().on('value', (snapCustomers) => {
          vm.customers = []
          const data = snapCustomers.val()
          if (data) {
            const customerKeys = Object.keys(data)
            for (let i = 0; i < customerKeys.length; i++) {
              let cKey = customerKeys[i]
              if (cKey !== 'TotalSites') {
                let currentCustomer = data[cKey]
                console.log(currentCustomer)
                let customer = {
                  '.key': cKey,
                  CustomerKey: cKey,
                  Name: currentCustomer.Name,
                  Email: '',
                  Address: '',
                  Phone: '',
                  Dealer: dealer ? dealer.title : '',
                  DealerKey: dealer ? dealer.value : '',
                  TotalPrinters: currentCustomer.TotalPrinters,
                  TotalSites: currentCustomer.TotalSites
                }
                /*
                db.ref('Printers').orderByChild('CustomerKey').equalTo(cKey).once('value').then(function (snapItems) {
                  let printersUser = snapItems.val()
                  if (printersUser) {
                    customer.TotalPrinters = Object.keys(printersUser).length
                  }
                  vm.isLoading = false
                })
                */
                vm.customers.push(customer)
              }
            }
          }
          vm.isLoading = false
        })
      },
      rowClick (btn, item) {
        switch (btn) {
          case 'Edit': this.edit(item); break
          case 'Delete': this.confirmDelete(item); break
          default: break
        }
      },
      edit (item) {
        let vm = this
        let path = 'Settings/CustomerSettings/' + item['.key']
        // path = 'CustomerSettings/' + item['.key']
        db.ref(path).once('value').then(function (snapCustomerSettings) {
          let custSettingsObj = snapCustomerSettings.val()
          if (custSettingsObj) {
            item.settings = custSettingsObj
          } else {
            item.settings = null
          }
          vm.$bus.$emit('customerModal-open', item)
        })
      },
      confirmDelete (item) {
        const vm = this
        vm.$bus.$emit('modal-open', {
          title: 'Delete Customer',
          description: 'Are you sure you want to delete customer [' + item.Name + ']',
          type: 'modal-primary',
          confirmText: 'Delete',
          cancelText: 'Cancel',
          confirmBefore: () => {
          },
          confirmAfter: () => {
            console.log(item)
            const customerRef = db.ref('Dealers/' + vm.filters.dealerKey + '/Customers/' + item['.key'])
            customerRef.remove()
            db.ref('Dealers/' + vm.filters.dealerKey + '/TotalCustomers').once('value').then(function (snapTotalCustomers) {
              let totalCustomers = snapTotalCustomers.val()
              db.ref('Dealers/' + vm.filters.dealerKey + '/TotalCustomers').set(totalCustomers - 1)
            })
            // vm.$root.loadSlideItems()
          },
          cancelBefore: () => {
          },
          cancelAfter: () => {
          }
        })
      },
      collectAllCounters (isInit) {
        console.log('collectAllCounters...')
        // let isInit = false
        const vm = this
        vm.progressCounters = {
          Total: 0,
          Success: 0,
          Failed: 0
        }
        vm.isLoading = true
        if (isInit) {
          HistoryCounters.Init(vm, db, dbStore).then(function (result) {
            console.log(result)
            vm.isLoading = false
          }).catch(function (err) {
            console.log(err)
            vm.isLoading = false
          })
        } else {
          HistoryCounters.Load(vm, dbStore).then(function (result) {
            let dealerKey = result.Data.DealerKey
            let customerKey = result.Data.CustomerKey
            let countersArr = result.Data.CountersArr
            console.log(countersArr)
            if (!(countersArr && countersArr.length > 0)) {
              alert('Run InitCounters() then continue ...')
              vm.collectAllCounters(true)
              return
            }
            vm.progressCounters = {
              Total: countersArr.length,
              Success: 0,
              Failed: 0
            }
            const startDate = vm.$moment(vm.selectedMonth + '/01', 'YYYY/MM/DD')
            const endDate = startDate.add(1, 'months').add(-1, 'days')
            const firstDayFirstHour = vm.$moment(startDate).format('YYYY-MM-DD') + ' 00:00:00'
            const lastDayLastHour = vm.$moment(endDate).format('YYYY-MM-DD') + ' 23:59:59'
            console.log('firstDayFirstHour: ' + firstDayFirstHour)
            console.log('lastDayLastHour: ' + lastDayLastHour)
            HistoryCounters.Get(vm, dbStore).then(function (result) {
              console.log(result)
              // let PrevCountersAscending = result.Data.PrevCounters
              // let PrevCountersDescending = result.Data.PrevCounters
              // let CurrentCountersAscending = result.Data.CurrentCounters
              // let CurrentCountersDescending = result.Data.CurrentCounters.reverse()
              // Use .slice(0) to copy the array to new variable
              let PrevCountersDescending = result.Data.PrevCounters.slice(0).sort(function (a, b) {
                if (a.LoggedInt < b.LoggedInt) return 1
                if (a.LoggedInt > b.LoggedInt) return -1
                return 0
              })
              let CurrentCountersAscending = result.Data.CurrentCounters.slice(0).sort(function (a, b) {
                if (a.LoggedInt < b.LoggedInt) return -1
                if (a.LoggedInt > b.LoggedInt) return 1
                return 0
              })
              let CurrentCountersDescending = result.Data.CurrentCounters.slice(0).sort(function (a, b) {
                if (a.LoggedInt < b.LoggedInt) return 1
                if (a.LoggedInt > b.LoggedInt) return -1
                return 0
              })
              if (PrevCountersDescending[0] && PrevCountersDescending[0].Logged) {
                console.log('PrevCountersDescending[0].Logged: ' + PrevCountersDescending[0].Logged)
              }
              if (CurrentCountersAscending[0] && CurrentCountersAscending[0].Logged) {
                console.log('CurrentCountersAscending[0].Logged: ' + CurrentCountersAscending[0].Logged)
              }
              if (CurrentCountersDescending[0] && CurrentCountersDescending[0].Logged) {
                console.log('CurrentCountersDescending[0].Logged: ' + CurrentCountersDescending[0].Logged)
              }
              console.log(CurrentCountersAscending)
              console.log(CurrentCountersDescending)
              let collectionPath = '/CountersHistory/Dealers/' + dealerKey + '/Customers/' + customerKey + '/' + vm.selectedMonth
              countersArr.forEach(function (counter) {
                HistoryCounters.Update(vm, dbStore, counter, collectionPath, PrevCountersDescending, CurrentCountersDescending, CurrentCountersAscending).then(function (resultUpdate) {
                  console.log(resultUpdate)
                  vm.progressCounters.Success++
                }).catch(function (errUpdate) {
                  console.log(errUpdate)
                  vm.progressCounters.Failed++
                })
              })
              vm.isLoading = false
            }).catch(function (err) {
              console.log(err)
              vm.isLoading = false
            })
          }).catch(function (err) {
            console.log(err)
            vm.isLoading = false
          })
        }
      }
    }
  }
</script>
<style>
  .spinner {
    position: absolute;
    left: 50%;
    top: 50%;
    height: 60px;
    width: 60px;
    margin: 0px auto;
    -webkit-animation: rotation .6s infinite linear;
    -moz-animation: rotation .6s infinite linear;
    -o-animation: rotation .6s infinite linear;
    animation: rotation .6s infinite linear;
    border-left: 6px solid rgba(0,174,239,.15);
    border-right: 6px solid rgba(0,174,239,.15);
    border-bottom: 6px solid rgba(0,174,239,.15);
    border-top: 6px solid rgba(0,174,239,.8);
    border-radius: 100%;
  }

  @-webkit-keyframes rotation {
    from {
      -webkit-transform: rotate(0deg);
    }

    to {
      -webkit-transform: rotate(359deg);
    }
  }

  @-moz-keyframes rotation {
    from {
      -moz-transform: rotate(0deg);
    }

    to {
      -moz-transform: rotate(359deg);
    }
  }

  @-o-keyframes rotation {
    from {
      -o-transform: rotate(0deg);
    }

    to {
      -o-transform: rotate(359deg);
    }
  }

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(359deg);
    }
  }
</style>




// WEBPACK FOOTER //
// Customers.vue?511ee933